import { marketAsyncComponent } from '@/utils/asyncComponent';

export default marketAsyncComponent('common-select', '0.0.1');
